import { createBrowserRouter } from "react-router-dom";
import Demo from "./Components/Pages/Demo/Demo";
import Homepage from "./Components/Pages/Homepage";

//
// "/" and "/site/**/*" routes to within this app.
//
// So each route should include "/route and /site/route.
//
export const router = createBrowserRouter([
  {
    path: "/",
    element: <Homepage />,
    errorElement: "There was an error with the homepage.",
  },
  {
    path: "/demo",
    element: <Demo />,
    errorElement: "There was an error with the UI demo page.",
  },
  {
    path: "/site/demo",
    element: <Demo />,
    errorElement: "There was an error with the UI demo page.",
  },
]);
